const DUST = [
  { x: 10, y: 8, r: 0.7, delay: 0, dur: 3.4, opacity: 0.32 },
  { x: 22, y: 18, r: 0.5, delay: 0.6, dur: 4.1, opacity: 0.22 },
  { x: 34, y: 6, r: 0.9, delay: 1.2, dur: 3.0, opacity: 0.4 },
  { x: 48, y: 22, r: 0.6, delay: 0.3, dur: 3.8, opacity: 0.26 },
  { x: 60, y: 10, r: 0.8, delay: 1.5, dur: 3.2, opacity: 0.34 },
  { x: 72, y: 26, r: 0.5, delay: 0.9, dur: 4.4, opacity: 0.2 },
  { x: 84, y: 14, r: 1.0, delay: 0.15, dur: 2.8, opacity: 0.38 },
  { x: 16, y: 30, r: 0.6, delay: 1.8, dur: 3.6, opacity: 0.24 },
  { x: 92, y: 28, r: 0.7, delay: 0.45, dur: 3.9, opacity: 0.3 },
  { x: 40, y: 34, r: 0.4, delay: 2.1, dur: 4.2, opacity: 0.18 },
];

export default function AmbianceBerghainAtmosphere() {
  return (
    <span
      className="mode-tile__atmosphere mode-tile__atmosphere--berghain"
      aria-hidden="true"
    >
      <span className="mode-tile__berghain-haze" />
      <span className="mode-tile__berghain-strobe" />
      <span className="mode-tile__berghain-strobe mode-tile__berghain-strobe--late" />
      <svg
        className="mode-tile__berghain-svg"
        viewBox="0 0 100 40"
        preserveAspectRatio="none"
        focusable="false"
      >
        {DUST.map((mote, index) => (
          <circle
            key={index}
            className="mode-tile__berghain-dust"
            cx={mote.x}
            cy={mote.y}
            r={mote.r}
            style={{
              opacity: mote.opacity,
              animationDelay: `${mote.delay}s`,
              animationDuration: `${mote.dur}s`,
            }}
          />
        ))}
      </svg>
    </span>
  );
}
